import { ApiService } from '@services/api.service';
import { TableDataApiParams } from '@services/practices.service';
import { Observable, throwError } from 'rxjs';
import { TablePaginationRespModel } from '@/models/table-pagination-resp.model';
import { RentalReservationModel } from '@/models/rentals/rental-reservation.model';
import { catchError, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RentalPracticeReservationService extends ApiService {
  getDataForTable(
    params?: TableDataApiParams,
  ): Observable<TablePaginationRespModel<RentalReservationModel>> {
    const id = params.id;
    delete params.id;

    return new Observable<TablePaginationRespModel<RentalReservationModel>>((observer) => {
      this.http
        .get<TablePaginationRespModel<RentalReservationModel>>(
          this.baseUrl + `/rental-practices/${id}/rentalReservation/page`,
          { params: { ...params } },
        )
        .pipe(
          tap((response) => {
            observer.next(response);
            observer.complete();
          }),
          catchError((error) => {
            console.error('Error occurred:', error.message);
            observer.error(error);

            return throwError(error);
          }),
        )
        .subscribe();
    });
  }
}
